import { render } from "./VaBeneIngredientCategoryListPage.vue?vue&type=template&id=c09fa7ca&ts=true"
import script from "./VaBeneIngredientCategoryListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneIngredientCategoryListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__